import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; 
import './StoryFestRegistrationPage.css';

const StoryFestRegistrationPage = () => {
  const navigate = useNavigate(); 
  
  // ==========================================
  // 🔒 HIDDEN CONSTANTS (Do not display on page)
  // ==========================================
  const EDITION_NAME = "StoryFest 2026";
  const TICKETING_TYPE = "Regular";
  const CREATED_BY = "Website";

  // Form State
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '', // Optional
    organization: ''
  });

  // UI State
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');

    // Combine visible form data with hidden constants
    const payload = {
      ...formData,
      editionName: EDITION_NAME,
      ticketingType: TICKETING_TYPE,
      createdBy: CREATED_BY
    };

    try {
      const response = await fetch('https://deeppink-turkey-495727.hostingersite.com/api/storyfest/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setIsSuccess(true);
        // Optionally clear form
        setFormData({ fullName: '', phone: '', email: '', organization: '' });
      } else {
        // Handle backend validation errors (like duplicate email)
        setErrorMessage(data.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setErrorMessage('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="storyfest-reg-page">
      
      {/* Background Texture */}
      <div className="storyfest-reg-bg-pattern"></div>

      {/* Navigation */}
      <div className="storyfest-reg-nav">
        <Link to="/storyfest" className="storyfest-reg-back-link">← Back to StoryFest</Link>
      </div>

      <div className="storyfest-reg-container">
        
        {/* LEFT SIDE: Title & Information */}
        <div className="storyfest-reg-info">
          <p className="storyfest-reg-label">WELCOME TO AMPLE HOUSE</p>
          
          <h1 className="storyfest-reg-title">
            StoryFest<br />
            <span className="storyfest-reg-text-gold">2026</span>
          </h1>
          
          <p className="storyfest-reg-desc">
            Register for free to experience the magic of StoryFest 2026. Join us for three days of books, culture, food, Made-in-Ghana discoveries, and shared wonder.
          </p>

          <div className="storyfest-reg-details">
            <div className="storyfest-reg-detail-item">
              <span className="storyfest-reg-detail-icon">📍</span>
              <div>
                <p className="storyfest-reg-detail-label">VENUE</p>
                <p className="storyfest-reg-detail-value">Accra City Hotel, Accra, Ghana</p>
              </div>
            </div>
            <div className="storyfest-reg-detail-item">
              <span className="storyfest-reg-detail-icon">📅</span>
              <div>
                <p className="storyfest-reg-detail-label">DATE</p>
                <p className="storyfest-reg-detail-value">11th — 13th December 2026</p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE: Registration Form */}
        <div className="storyfest-reg-form-wrapper">
          
          {isSuccess ? (
            <div className="storyfest-reg-success">
              <div className="storyfest-reg-success-icon"></div>
              <h2>Registration Completed!</h2>
              <p>Thank you for registering for StoryFest 2026. We look forward to seeing you at the Accra City Hotel. See you there!</p>
              <button 
                onClick={() => navigate('/storyfest')} 
                className="storyfest-reg-btn-submit" 
                style={{ marginTop: '2rem' }}
              >
                Return to StoryFest
              </button>
            </div>
          ) : (
            <form className="storyfest-reg-form" onSubmit={handleSubmit}>
              <h2 className="storyfest-reg-form-title">Secure Your Spot</h2>
              <p className="storyfest-reg-form-subtitle">Please fill in your details below.</p>

              {errorMessage && (
                <div className="storyfest-reg-error">
                  {errorMessage}
                </div>
              )}

              <div className="storyfest-reg-input-group">
                <label htmlFor="fullName">Full Name *</label>
                <input 
                  type="text" 
                  id="fullName" 
                  name="fullName" 
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder=""
                  required 
                />
              </div>

              <div className="storyfest-reg-input-group">
                <label htmlFor="phone">Phone Number *</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder=""
                  required 
                />
              </div>

              <div className="storyfest-reg-input-group">
                <label htmlFor="email">Email Address <span className="optional">(Optional)</span></label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  placeholder=""
                />
              </div>

              {/* UPDATED: Organization is now required */}
              <div className="storyfest-reg-input-group">
                <label htmlFor="organization">Organization *</label>
                <input 
                  type="text" 
                  id="organization" 
                  name="organization" 
                  value={formData.organization}
                  onChange={handleChange}
                  placeholder=""
                  required
                />
              </div>

              <button 
                type="submit" 
                className="storyfest-reg-btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Registering...' : 'Register for Free →'}
              </button>

              <p className="storyfest-reg-privacy">
                By registering, you agree to receive event updates via SMS.
              </p>
            </form>
          )}

        </div>

      </div>
    </div>
  );
};

export default StoryFestRegistrationPage;